import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const AdminLogin = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      // In a real implementation, this would send to your API
      // For now, we'll simulate with a timeout and hardcoded credentials
      setTimeout(() => {
        if (username === 'admin' && password === 'admin#321ma') {
          // Store auth token and user info in localStorage
          localStorage.setItem('authToken', 'simulated-jwt-token');
          localStorage.setItem('user', JSON.stringify({ username: 'admin', role: 'admin' }));
          
          // Call the onLogin callback if provided
          if (onLogin) {
            onLogin();
          }
          
          // Navigate to admin dashboard
          navigate('/admin');
        } else {
          setError('Invalid username or password');
        }
        setLoading(false);
      }, 1000);
    } catch (err) {
      setError('Login failed. Please try again.');
      setLoading(false);
    }
  };
  
  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <Link to="/" className="site-logo text-2xl">
            CoreLink<span>AI</span> Blog
          </Link>
        </div>
        
        <h1 className="login-title">Admin Login</h1>
        
        {error && (
          <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6">
            <p className="text-red-700">{error}</p>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username" className="form-label">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="form-input"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input"
              required
            />
          </div>
          
          <button
            type="submit"
            className="btn btn-primary w-full"
            disabled={loading}
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Logging in...
              </span>
            ) : 'Login'}
          </button>
        </form>
        
        <div className="login-footer">
          <p>Return to <Link to="/" className="text-primary hover:text-primary-dark">Blog Home</Link></p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
